import { FC, ReactNode } from 'react';
import { Heading, Header, ApplyButton } from 'components';
import { font } from 'style';
import S from './HeaderSection.Styled';

interface HeaderSectionProps {
  title: ReactNode;
  subtitle?: ReactNode;
  applyLink?: string;
  disableApply?: boolean;
  image: string;
  imageWidth: number;
  imageAlt: string;
  unavailableContent?: ReactNode;
  onApply?: React.MouseEventHandler<HTMLButtonElement>;
}

export const HeaderSection: FC<HeaderSectionProps> = ({
  title,
  subtitle = null,
  applyLink,
  disableApply,
  image,
  imageWidth,
  imageAlt,
  unavailableContent,
  onApply,
}) => {
  return (
    <Header>
      <S.Container>
        <S.TextContainer>
          <S.Title>
            <Heading color="white" fontWeight={font.weight.bold}>
              {title}
            </Heading>
          </S.Title>
          <S.SubText>{subtitle}</S.SubText>
          {applyLink && onApply && (
            <S.ButtonContainer>
              <ApplyButton
                href={applyLink}
                unavailable={disableApply}
                unavailableContent={unavailableContent}
                onClick={onApply}
              />
            </S.ButtonContainer>
          )}
        </S.TextContainer>
        <S.ImageContainer width={imageWidth}>
          <img src={image} alt={imageAlt} />
        </S.ImageContainer>
      </S.Container>
    </Header>
  );
};
